import clsx from 'clsx';
import { Button as AriaButton } from 'react-aria-components';

import type { PaidBreakExceptionReason } from '#/shared/types/PaidBreakRequest';
import { focusRingClassName } from '#/shared/utils/domHelper';

import { PaidBreakExceptionCollapsible } from './PaidBreakExceptionCollapsible';
import { PaidBreakExceptionDetails } from './PaidBreakExceptionDetails';

type PaidBreakExceptionRejectedContentProps = {
  reason?: PaidBreakExceptionReason;
  notes?: string;
  approverNotes?: string;
  statusMessage?: string | null;
  defaultExpanded?: boolean;
  onRejectionNoteOpen?: () => void;
  onRejectionNoteDelete?: () => void;
  showRejectionNote?: boolean;
};

export function PaidBreakExceptionRejectedContent({
  reason,
  notes,
  approverNotes,
  statusMessage,
  defaultExpanded = false,
  onRejectionNoteOpen = () => {},
  onRejectionNoteDelete = () => {},
  showRejectionNote = true,
}: Readonly<PaidBreakExceptionRejectedContentProps>) {
  const defaultStatusMessage = statusMessage ? statusMessage : 'No change has been made to the timesheet.';

  return (
    <>
      <PaidBreakExceptionCollapsible defaultExpanded={defaultExpanded} title={defaultStatusMessage}>
        <PaidBreakExceptionDetails reason={reason} notes={notes} />
      </PaidBreakExceptionCollapsible>

      {showRejectionNote && !!approverNotes && (
        <div className="mt-8 p-16 bg-surface-l1 rounded-md border-outline-l4 border-1">
          <div className="pb-8">
            <strong className="font-700">Rejection note:</strong> <span className="break-all">{approverNotes}</span>
          </div>
          <div className="flex flex-row justify-between">
            <AriaButton
              onPress={onRejectionNoteOpen}
              className={clsx(
                'text-left text-base text-primary hover:text-primary-shade cursor-pointer',
                focusRingClassName,
              )}
            >
              Edit
            </AriaButton>
            <AriaButton
              onPress={onRejectionNoteDelete}
              className={clsx(
                'text-left text-base text-error hover:text-error-on-surface cursor-pointer',
                focusRingClassName,
              )}
            >
              Delete
            </AriaButton>
          </div>
        </div>
      )}

      {showRejectionNote && !approverNotes && (
        <div className="mt-8">
          <AriaButton
            onPress={onRejectionNoteOpen}
            className={clsx(
              'text-left text-base text-primary hover:text-primary-shade cursor-pointer',
              focusRingClassName,
            )}
          >
            Add rejection note
          </AriaButton>
        </div>
      )}
    </>
  );
}
